import { Box, type BoxProps } from '@chakra-ui/react'
import type { ReactElement } from 'react'

export type EmojiProps = BoxProps & {
  label?: string
  symbol: string
}

export function Emoji(props: EmojiProps): ReactElement {
  const { label, symbol, ...restProps } = props
  return (
    <Box
      as="span"
      aria-hidden={label ? undefined : true}
      aria-label={label ? label : undefined}
      role="img"
      {...restProps}
    >
      {symbol}
    </Box>
  )
}
